import cn from "classnames";

const HDLoadingButton = ({
    loading = false,
    disabled = false,
    onClick,
    type = "button",
    children,
    className = "",
    variant = "primary",
    ...props
}: {
    loading?: boolean;
    disabled?: boolean;
    type: "button" | "submit" | "reset";
    children: React.ReactNode;
    className?: string;
    variant?: "primary" | "secondary";
    onClick?: () => void;
} & React.ButtonHTMLAttributes<HTMLButtonElement>) => {
    const handleClick = () => {
        if (!loading && !disabled && onClick) {
            onClick();
        }
    };

    return (
        <button
            type={type}
            className={cn(
                className,
                variant === "secondary" ? "secondary-button" : "primary-button",
                loading && "loading-button",
            )}
            onClick={handleClick}
            disabled={disabled || loading}
            {...props}
        >
            {loading ? (
                <span className="flex justify-center items center text-center">
                    <div
                        className="inline-block h-5 w-5 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
                        role="status"
                    ></div>
                </span>
            ) : (
                children
            )}
        </button>
    );
};

export default HDLoadingButton;
